module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الفصل-الرابع-نور-الدين-محمود-زنكي"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الفصل الرابع")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نور الدين محمود زنكي")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مِن بين أولاد عماد الدين زنكي الثلاثة كان أصغرهم هو النجم الصاعد المتألِّق \"نور الدين محمود\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تولى الابن الأكبر سيف الدين حكم المقاطعة الشرقية (شمال العراق) ومركزها الموصل، وورَّث حكمها للابن الأوسط قطب، وترك المقاطعة الغربية وعاصمتها حلب لنور الدين زنكي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وُلِدَ نور الدين محمود زنكي في سنة ١١١٨م بحلب، وقد نشأ في كفالة والده، تعلَّم القرآن والفروسية والرماية، وصفُوه بأنَّه كان شهمًا شجاعًا ذا همَّة عالية، وقصدٍ صالحٍ، وحرمة وافرة، وديانة بيِّنة، يتَّسِم بالتقوى، محبًّا للعدل، ممَّا جعله قائدًا بالفطرة، ورثَ بعض صفات أبيه التي تجعل منه رجل دولة، شجاعًا، متقشِّفًا غير مسرف، لكنَّه لَم يرث القسوة وغلظة القلب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فالأب كان يصل إلى ما يريد باستخدام الخوف والشدَّة، أمَّا نور الدين فكان يحصل على ما يريد بالذكاء والصبر وسموٍّ في التفكير.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بالوصف المعاصر كان نور الدين يحكم باستخدام \"القوة الناعمة\"، كانت غايته الوصول إلى الهدف الذي كان يحلم به والده.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأ حملة دِعائية مكثَّفة عيَّن مِن أجلها مجموعة مِن الشعراء والكتَّاب والمثقَّفين لنشر الأشعار والكتب للتأثير على الرأي العام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان يعلم ثَمَن نشر أوصاف حميدة له، مثل التقشُّف، والعدل، وخفض الضرائب، والكرم، والعطف على المحتاجين، والتمسُّك بتعاليم الإسلام")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn1",
      "id": "fnref1"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وصفه ابن الأثير بأنَّه: \"رجل فارع داكن اللون بلحية، لكن مِن دون شارب، هيئته جذَّابة ذات عيون تذيب مَن ينظر إليها\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ويقول ابن الأثير في بيان فضله")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn2",
      "id": "fnref2"
    }
  }, [_vm._v("2")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(":")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("\"قد طالعتُ تواريخ الملوك المتقدِّمين قَبل الإسلام وفِيه إلى يومنا هذا، فلَم أرَ بعد الخلفاء الراشدين وعمر بن عبد العزيز أحسن سيرة مِن الملك العادل نور الدين، ولا أكثر تحرِّيًا للعدل والإنصاف منه، قد قَصَر ليله ونهاره على عدلٍ ينشره، وجهاد يتجهَّز له، ومظلمة يزيلها، وعبادة يقوم بها، وإحسان يولِّيه، وإنعام يسديه، فنور الدين لَم يأبه بأبَّهة الحكم والسلطان، ولَم يتقاضَ راتبًا مِن بيت مال المسلمين، وإنَّما كان يأكل ويلبس هو وأهله مِن ماله الخاص، ولَم يكن له بيت يسكنه، وإنَّما كان مقامه في غرفة في قلعة قد اشتراها مِن ماله، يحلُّ فيها عندما يعود مِن ساحة الجهاد\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حكى ابن الأثير قصَّة أنَّ زوجة نور الدين اشتكَت إليه مِن عدم وجود مبالغ كافية لقضاء حاجة البيت، كان نور الدين يمتلك ثلاثة دكاكين في حمص، رصد دخلها لزوجته تنفق مِن أرباحها، قال لها: \"لا أملك غير ذلك، كل المبالغ في خزانة المسلمين للمسلمين، لن أخون أمانتهم، ولن أَدخل جهنَّم مِن أجلك\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان يشتري طعامه بنفسه مِن دون الاحتياج لخدَم، كان يحترم الشريعة الإسلامية مِن غير تطرُّف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت مِن صفاته الحميدة شعوره بالمسؤولية الملقاة على عاتقه، واعتماده الحلول العقلية، وقوة شخصيته، كما تمتَّع بخصائص عسكرية فذَّة جعلَته مِن أعظم قادة زمانه، ومكنَّته مِن تحويل جيشه الصغير إلى أعظم قوة عسكرية في الشرق الأوسط، كما كان رياضيًّا مِن الطراز الأول، مولعًا بضرب الكرة \"البولو\"")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn3",
      "id": "fnref3"
    }
  }, [_vm._v("3")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("، ومارَس أيضًا رياضة الصيد، وكان تقيًّا ورعًا شغوفًا بالعلم، مُعَظِّمًا للعلماء، يختار رجال دولته بعناية فائقة، وقد منحَ المؤسَّسة القضائية استقلالًا تامًّا، وأنشأ دار العدل التي كانت بمنزلة محكمة عليا لمحاسبة كبار الموظفين في الدولة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تحرَّى العدل، وأنصف المظلوم مِن الظالم دون النظر إلى الفوارق الاجتماعية، كما كان حريصًا على تأمين الخدمات الاجتماعية لرعيَّته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان نور الدين في الثامنة والعشرين حين تولَّى حُكم حلب، في وقت ساد فيه الاضطراب بعد مقتل زنكي، كانت الناس مشوَّشة وأصبحَت الشوارع غير آمِنة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شكَّ البعض في أحقِّيَّة وقدرة نور الدين على الحكم، واعتزل عدد مِن كبار الضباط في الجيش، لكن نور الدين تمكَّن مِن استقطاب وتعيين شيركوه عمِّ صلاح الدين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وفي عام 1146م سنحَتِ الفرصة ليؤكِّد نور الدين محمود قدرته على القيادة والحكم، كان الأرمن داخل مدينة الرُّها قد طلبوا مِن الكونت جوسلين الثاني الحاكم السابق محاولة استعادة المدينة مِن المسلمين بعد وفاة زنكي بشهرين، فزحف جوسلين بجيش سريع التجميع، ووصل للرُّها في ليلة مِن نوفمبر ١١٤٦م، ودخلها بعد هدم جزء مِن السور، فاختبأ المسلمون بالقلعة وحوصروا بها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان ردُّ فِعل نور الدين سريعًا، كان يكره أن تسقط الرُّها في أيدي الفرنج، وكان لا يريد أن يحصل أخوه سيف الدين على شرف تحريرها والاستيلاء عليها، فجمع آلافًا مِن جنود حلب والمحاربين الأتراك، وانطلق بسرعة كبيرة ليلًا ونهارًا حتَّى كانت الخيول تتساقط على جانبي الطريق مِن التَّعب، وجاءَت هذه السرعة في صالحه، لَم يكن جوسلين يملك منجنيقًا واحدًا أو عددًا كافيًا مِن الجنود لدخول القلعة، فوجد نفسه محاصَرًا مِن الأمام (المسلمين في القلعة) ومِن الخلف (جيوش نور الدين)، وانهزم جوسلين، ووقع أسيرًا، وقد تكبَّد خسائر فادحة، وسُجِن جوسلين في حلب، ومات بعد تسع سنين")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn4",
      "id": "fnref4"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد دخول الرُّها ورجوعها تحت حكمه، آثَر نور الدين أن يثبت قسوته في الحرب، عندما فتح والده المدينة مِن سنتين، أعطى حَصانة للمسيحيين الشرقيين، لكن الآن ونتيجة تواطُئِهم مع الفرنج قتل كل رجالهم، وأخذ كل نسائهم وأطفالهم سبايا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استخدَم نور الدين أسلوب والده في القوة الشرسة لتوطيد مركزه في هذا الموقف، لكن ذلك التصرُّف لن يدوم"), _c('sup', [_vm._v("1.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان هدف نور الدين توطيد العلاقة بين حلب ودمشق، فنجح في الزواج مِن ابنة معين الدين أنر حاكم دمشق، عصمة الدين خاتون، ثمَّ تبعَ ذلك بإطلاق سراح أمة مستعبَدة قبض عليها زنكي في بعلبك سنة ١١٣٨م، وكانت عشيقة أنر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد توطُّد العلاقة بين حلب ودمشق آثَر أنر إنهاء أي اتفاقيات مع الفرنج، لكنَّ واحدًا مِن أتباعه \"التونتاش\" حاكم بصرى الشام التي تقع جنوب دمشق، حاول الرجوع إلى الفرنج، فأرسلَتِ القدس قوَّة لحمايته، تدخَّل معين الدين أنر لمنع ذلك، وزحف بجنوده ومعه جيش نور الدين إلى بصرى الشام، ومنعوا الفرنج مِن دخولها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حصل أنر على استحسان الخليفتين الفاطمي والعباسي، لكن تبع ذلك علوّ مقام دمشق على حلب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تُوُفِّي معين الدين أنر بعد عام، وأصبحَت دمشق فاكهة ناضجة تنتظر نور الدين لقطفها، لكنَّه آثَر دخولها بسلام للحفاظ على الوحدة الوطنية وسُمعته كرجل سلام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وفي يونيو عام ١١٤٩م حاصر المدينة، وأعلن أنَّه لا يريد الحرب، لكنَّه يلبِّي نداء الأطفال والفقراء المزارعين الذين نهبَ الفرنج محاصيلهم، ولَم يجدوا مَن يحميهم"), _c('sup', [_vm._v("،")]), _vm._v(" وبالتالي اطمأَنَّ له أهالي دمشق، وفتحوا الأبواب ورحَّبوا به.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وفي الجمعة التالية كان اسمه يُذكَر في دعاء الصلاة إلى جانب اسم الخليفة والسلطان، وبعد سنة رجع نور الدين يساوم سلطان دمشق الحاكم الجديد ذا الأعوام التسعة عشرَ (أباق) بالتعاون العسكري لتوحيد الصفوف أمام الصليبيين، ولكنَّ أباق رفض وأبقى على خيط مِن العلاقات مع الفرنج.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صبر نور الدين، وفضَّل تخطيط ثورة داخلية عن الحرب، وزرع روحًا مِن عدم الثقة بين السلطان ومعاونيه خاصَّةً مِن الجيش، وكان أيوب حلقة الوصل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان صلاح الدين في الخامسة عشرة، وعلى دراية بما يدور حوله، وبعد أربع سنوات أرسل نور الدين لأباق رسالة يخبره فيها أنَّ هناك مؤامرة تخطَّط ضدَّه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هلع أباق، وأعدم عددًا مِن المشتبَه فيهم، وبالتالي أصبح منعزلًا، وسارع نور الدين بوقف إمداد الطعام لدمشق، وبدأَت علامات الجوع والغليان، وسادت شائعات أنَّ السبب هو أباق والفرنج.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وصل جيش نور الدين يحوط دمشق في ٢٥ أبريل1154م، قامت امرأة يهودية برمي حبل مِن فوق السور، وتسلَّق بعض الجنود إلى داخل دمشق، وفتحوا الأبواب، ودخل نور الدين وسط هتاف الجماهير السعداء بالنجاة مِن المجاعة والفرنج، وتابَع نور الدين عربات مليئة بالفواكه والطعام، وأثبت نور الدين الكرم عند النصر، وأطلق سراح أباق وعائلته، وأعطاهم إقطاعيَّات في حمص")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn5",
      "id": "fnref5"
    }
  }, [_vm._v("5")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأ نور الدين الحكم بإسقاط ما كان يؤخذ مِن (المكوس) الضرائب غير الإسلامية والمكروهة مِن الشعب، مثل الضرائب على المحاصيل الزراعية كالخضار والبطيخ، والضرائب المفروضة على استخدام المراكب في القنوات المائية، وأعطى عرب البادية إقطاعيَّات لكَي يكفُّوا عن التعرُّض للحُجَّاج، وقام بتحصين بلاد الشام، وبنى الأسوار على مدنها، وبنى مدارس كثيرة منها العادلية والنورية، ويُعتبَر نور الدين أوَّل مَن بَنى مدرسة للحديث (دار الحديث)، وقام ببناء الجامع النوري بالموصل، والجامع النوري في مدينة حماة، وبنَى الخانات في الطرق، وكان متواضعًا مهيبًا وقورًا، يكرم العلماء، وكان فقيهًا على المذهب الحنفي، فكان يجلس في كلِّ أسبوع أربعة أيام يحضُر الفقهاء عنده، ويأمر بإزالة الحجاب حتَّى يصل إليه مَن يشاء، ويسأل الفقهاء عمَّا يصعب عليه، ووقف نور الدين كتبًا كثيرة ليقرأها الناس، وغير ذلك مِن الإنجازات العظيمة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قال ابن الأثير: \"وهو أوَّل مَن بنى دارًا للعدل، وكان يجلس فيها في الأسبوع مرَّتَين، وقيل أربع مرَّات، وقيل خمس، ويحضر القاضي والفقهاء مِن سائر المذاهب، ولا يحجبه يومئذٍ حاجب ولا غيره، بل يصل إليه القوي والضعيف، فكان يكلِّم الناس، يسألهم ويخاطبهم بنفسه، فيكشف المظالم، وينصف المظلوم على الظالم\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عَظُم شأن أسد الدين شيركوه بن شادي عند نور الدين، حتَّى صار كأنَّه شريكه في المملكة، واقتنى الأملاك والأموال والمزارع والقرى، وربما قد ظلم أحد جيرانه أو نوَّابه في الأراضي والأملاك، وكان القاضي كمال الدين يُنصِف كلَّ مَن استعدَاه على جميع الأمراء إلا أسد الدين هذا، فما كان يهجم عليه، فلمَّا علم نور الدين بذلك ذهب إلى دار العدل وجلس.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تقدَّم أسد إلى نوَّابه ألَّا يَدَعوا لأحد عنده ظُلامة وإن كانت عظيمة، فإنَّ زوال ماله عنده أحبُّ إليه من أن يراه نور الدين بعين ظالم، أو يوقفه مع خصم مِن العامَّة، ففعلوا ذلك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فلمَّا جلس نور الدين بدار العدل مدَّة متطاولة ولَم يرَ أحدًا يستعدي على أسد الدين، سأل القاضي عن ذلك، فأعلمه بصورة الحال، فسجد نور الدين شكرًا لله، وقال: \"الحمد لله الذي جعل أصحابنا ينصفون مِن أنفسهم\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ليس ذلك فحسب، بل ارتبط اسمه بشرف عظيم، وهو حماية قبر النبي صلى الله عليه وآله وسلَّم مِن الهدم وسرقة الجسد الشريف للحبيب صلوات ربِّي وسلامه عليه وعلى آله، ولذلك قصة ذكَرها الكثير مِن المؤرِّخين والعلماء خاصَّةً الذين تناولوا سيرة الملك العادل نور الدين زنكي. (مصادر تلك القصة في آخِر الفصل).")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رأى الملك العادل نور الدين زنكي في المنام النبي صلى الله عليه وآله وسلم وهو يشير إلى رجلين أشقرَين ويقول: \"أنجِدني، أنقِذني مِن هذين\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاستيقظ نور الدين زنكي فزِعًا، ثمَّ توضَّأ وصلَّى ونام، فرأى نفس المنام بعينه مرة أخرى، فاستيقظ وصلَّى ونام، فرآه أيضًا بنفس تفاصيله مرَّة ثالثة، حينها علم أنَّ الأمر جلل، فاستيقظ وقال: \"لَم يبق نوم!\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وكان لنور الدين زنكي وزير مِن الصالحين يقال له جمال الدين الموصلي، فأرسل إليه، وحكى له ما وقع له، فقال له: \"وما قعودك؟! اخرج الآن إلى المدينة النبوية، واكتم ما رأيتَ\"، فتجهَّز في بقيَّة ليلته، وخرج إلى المدينة، وفي صحبته الوزير جمال الدين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اجتمع أهل المدينة في المسجد النبوي الشريف، فقال الوزير: \"إنَّ السلطان قصد زيارة النبي صلى الله عليه وآله وسلم، وأحضر معه أموالًا للصدقة، فاكتبوا مِن عندكم\"، فكتبوا أسماء أهل المدينة كلهم، وأمر السلطان بحضورهم، وكلُّ مَن حضر يأخذ يتأمَّله ليجد فيه الصفة التي أراها النبي صلى الله عليه وآله وسلم له، فلا يجد تلك الصفة، فيعطيه ويأمره بالانصراف، إلى أن انفضَّ النَّاس.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فقال نور الدين زنكي: هل بقي أحد لَم يأخذ شيئًا مِن الصدقة؟ قالوا: لا، فقال: تفكَّروا وتأمَّلوا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فقالوا: لَم يبق أحد إلا رجلَين مغربيَّين لا يتناولان مِن أحد شيئًا، وهما صالحان غنيَّان يكثران الصدقة على المحاويج، فانشرح صدره وقال: عَلَيَّ بهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فأُتِي بهما، فرأى الرجلَين اللَّذَين أشار النبي صلى الله عليه وآله وسلم إليهما بقوله: \"أنجِدني.. أنقِذني مِن هذَين\"، فقال لهما: مِن أين أنتما؟ فقالا: مِن بلاد المغرب، جئنا حاجَّين، فاخترنا المجاورة في هذا المقام عند رسول الله صلى الله عليه وآله وسلم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فقال: اصدُقاني، فصمَّما على ذلك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فقال نور الدين زنكي: أين منزلهما؟ فأخبر بأنَّهما في رباط بقرب الحجرة النبوية الشريفة، وأثنى عليهما أهل المدينة بكثرة الصيام والصدقة، وزيارة البقيع وقباء، فأمسكهما وحضر إلى منزلهما، وبقي السلطان يطوف في البيت بنفسه، فرفع حصيرًا في البيت، فرأى سردابًا محفورًا ينتهي إلى صوب الحجرة الشريفة، فارتاع الناس لذلك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فقال نور الدين زنكي: اصدقاني حالكما! وضربهما ضربًا شديدًا، فاعترفا بأنَّهما نصرانيَّان، بعثَهما النصارى في حجَّاج المغاربة، وأعطَوهما أموالًا عظيمة، وأمروهما بالتحايل لسرقة جسد النبي صلى الله عليه وآله وسلم، وكانا يحفران ليلًا، ولكلِّ منهما محفظة جلد على زِيّ المغاربة، والذي يجتمع مِن التراب يجعله كلٌّ منهما في محفظته، ويخرجان لإظهار زيارة البقيع فيلقيانه بين القبور، وأقاما على ذلك مدَّة، فلمَّا قربَا مِن الحجرة الشريفة أرعدَتِ السماء وأبرقَت، وحصل رجيف عظيم بحيث خُيِّل انقلاع تلك الجبال، فقدِم السلطان صبيحة تلك الليلة، فلمَّا اعترفا، وظهر حالهما على يديه، ورأى تأهيل الله له لذلك دون غيره، بكى نور الدين زنكي بكاءً شديدًا، وأمرَ بضرب رقابهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ليس ذلك فحسب، بل أمر نور الدين زنكي بحفر خندق عظيم حول الحجرة النبوية الشريفة كلها، وأمر بإحضار رصاص عظيم، وأُذِيب ذلك الرصاص، ومَلأ به الخندق، فصار حول الحجرة الشريفة سورٌ مِن الرصاص ليس له باب ولا مدخل إلى القبر النبوي الشريف.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('hr'), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "fn1"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نور الدين محمود سيرة مؤمن صادق- حسين مؤنس: الدار السعودية للنشر والتوزيع - جدة- السعودية 1408ه - 1987م")]), _vm._v("."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref1"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn2"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("\"الكامل في التاريخ\" المؤلف: "), _c('strong', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("عز الدين بن الأثير")])]), _vm._v("، المتوفى")]), _vm._v(" 630"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هـ،")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الناشر: دار الكتاب العربي - بيروت -")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لبنان، الطبعة")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأولى،")]), _vm._v(" 1417"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هـ / 1990.")]), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref2"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn3"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دور نور الدين محمود في نهضة الأمة ومقاومة غزو الفرنجة. رسالة دكتوراه: عبد القادر أحمد أبو صيني. الجامعة الأردنية ١٩٩٦، ص: ١٣٤.")]), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref3"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn4"
    }
  }, [_c('p', [_vm._v("Stanley Lane-Poole, \"SALADIN and the Fall of JERUSALEM\". Greenhill Books, London 2016. P "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("71-70")]), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref4"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn5"
    }
  }, [_c('p', [_vm._v("Stanley Lane-Poole, \"SALADIN and the Fall of JERUSALEM\". Greenhill Books, London 2016. P "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("73-72.")]), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref5"
    }
  }, [_vm._v("↩︎")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-476c534a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch011.vue
// module id = 93
// module chunks = 0